import { Action } from 'common/interfaces/root';
import { publishersSettingsActionTypes as T } from '../actions';

const initState: PublishersSettingsModule.TeamSettingsStore = {
  loading: true,
  error: null,
  data: null,
};

export default (
  state: PublishersSettingsModule.TeamSettingsStore = initState,
  { type, payload }: Action
): PublishersSettingsModule.TeamSettingsStore => {
  switch (type) {
    case T.GET_PUBLISHER_TEAM:
      return { ...state, loading: true };

    case T.GET_PUBLISHER_TEAM_SUCCESS:
      return { ...state, loading: false, data: payload.data };

    case T.GET_PUBLISHER_TEAM_ERROR:
      return { ...state, loading: false, error: payload };

    default:
      return state;
  }
};
